<template>

  <div class="mbg-city-selector w-md-75">
    <label v-if="title">{{title}}</label>

    <autocomplete :items="cities"
                  :input-class="hasCityError ? 'form-control is-invalid new-chart-input' : 'new-chart-input' "
                  :value="value"
                  :get-label="getLabel"
                  :component-item='template'
                  :auto-select-one-item="false"
                  @item-selected="citySelected"
                  :placeholder="$t('general.city')"
                  @change="updateCities"
                  :disabled="isFetchingCities || disabled"
    />
    <p class="form-error-indicator mb-0 mt-0" v-if="hasCityError">
      <span>Select (by clicking) a city from the list</span>
    </p>
  </div>
</template>

<script>
import Autocomplete from "../structure/Autocomplete/Autocomplete.vue";
import CountryAutocompleteItem from "./partials/CountryAutocompleteItem"

export default{

  props:{
    value: [Object, String],
    title: String,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  components:{Autocomplete},
  data(){
    return{
      cities: [],
      cityTextState: '',
      template: CountryAutocompleteItem,
      isFetchingCities: false,
      timer: null,
      searchId: 0,
    }
  },
  created(){
    // if we land with an existing city, we want to fetch it
    // in order to also derive the timezone.
    // This is super important for chart updates to function properly.
    if(this.value){
      this.searchCities(this.value.name).then(() => {
        const matchingCity = this.findCityMatchWithFallback(this.value);
        this.citySelected(matchingCity || this.value)
      })
    }
  },

  computed:{
    hasCityError(){
      return this.cityTextState.length > 0 && !this.value
    }
  },

  methods:{
    normalizeValue(value){
      return (value || '').toString().toLowerCase().trim();
    },
    findCityMatchWithFallback(value){
      if(!value || !this.cities.length) return null;
      const valueName = this.normalizeValue(value.name);
      const valueCountry = this.normalizeValue(value.country);
      const valueStateName = this.normalizeValue(value.stateName);
      const valueTimezone = this.normalizeValue(value.timezone);

      return this.cities.find(city =>
          this.normalizeValue(city.name) === valueName &&
          this.normalizeValue(city.country) === valueCountry &&
          this.normalizeValue(city.stateName) === valueStateName
      ) || this.cities.find(city =>
          this.normalizeValue(city.name) === valueName &&
          this.normalizeValue(city.country) === valueCountry &&
          this.normalizeValue(city.timezone) === valueTimezone
      ) || this.cities.find(city =>
          this.normalizeValue(city.name) === valueName &&
          this.normalizeValue(city.country) === valueCountry
      );
    },
    getLabel(item){
      if (!item) return '';
      if (typeof item === 'string') return item;
      if (item.country) {
        const country = this.$t('countries.' + item.country);
        const state = item.stateName ? ` ${item.stateName}` : '';
        return `${item.name}${state}, ${country}`;
      }
      return item.name;
    },
    citySelected(city){
      this.$emit('input', city);
    },
    updateCities(text) {
      this.cityTextState = text;
      // if city is empty, we don't search.
      // no reason to spam back-end with empty requests.
      if(!text || text === ''){
        this.clearResults();
        return;
      }
      // split the search if it includes the state name so we only search
      // by city name. Example: New York City (New York) -> New York City (search string)
      // debounce searching
      clearTimeout(this.timer);
      this.timer = setTimeout(()=>{
        this.searchId++;
        this.searchCities(text, this.searchId);
      }, 400);

    },
    clearResults(){
      this.cities = [];
      this.$emit('input', null);
    },
    searchCities(search, id){
      if(!search) return;
      const fixedSearch = search.split(" (")[0];

      return this.axios.get(
          process.env.VUE_APP_CITIES_V3_URL,
          {params: {search: fixedSearch}, timeout: 10000}
      ).then(res => {
          if (!!id && id < this.searchId) return;
          this.cities = res.data.map(el => ({
            name: el.name,
            country: el.country,
            timezone: el.timezone,
            stateName: el.stateName
          }));
      }).catch(()=>{
        this.$notify({type: 'error', title: this.$t('errors.general'), text: this.$t('errors.retry')});
      })
    },
  }
}
</script>